export const NAME = 'organization_resources'
export const ITEMS_PER_PAGE = 8
